
<body>
  <img src="https://png.pngtree.com/thumb_back/fw800/background/20190221/ourmid/pngtree-information-data-background-technology-cool-creative-business-image_17534.jpg" id="bg" alt="">
    <!--<a mat-raised-button color = "primary" href="https://sites.google.com/site/mrsnirmaliesmathclass/" target="_blank"><h3>Ms.Nirmalies website</h3></a>-->   
     <div class= 'testing'>
      <div class="row">
      <div class="col" >
       <!--<button mat-button routerLink = "csnotes">Computer Science Notes</button>-->

        <!--<button mat-button routerLink = "ictnotes">ICT notes</button>-->
      
   
   </div>
   </div>
 </div>
</body>

